<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="items"
        item-key="id"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        class="elevation-1"
        hide-default-footer
        disable-sort
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <user-form :id="editedId" @updated="loadDataFromServer" @closed="editedId = '0'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon class="mr-2">mdi-plus</v-icon>
                Přidat uživatele
              </v-btn>
            </template>
          </user-form>
          <confirm-dialog message="Opravdu odstranit uživatele?" :action="confirmAction" />
        </v-toolbar>
      </template>
      <template v-slot:item.admin="{ item }">
        <span>
          <v-chip v-if="item.admin === '0'">Přístup jen pro čtení</v-chip>
          <v-chip v-if="item.admin === '1'">Přístup pro čtení i zápis</v-chip>
        </span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
            small
            @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <v-dialog transition="dialog-top-transition" max-width="600">

    </v-dialog>
  </div>
</template>

<script>
import UserForm from "@/components/UserForm";
import ConfirmDialog from "@/components/ConfirmDialog";
import {api, defaultApiErrorHandler} from "@/main";

export default {
  name: 'UsersTable',
  components: {ConfirmDialog, UserForm},
  data () {
    return {
      total: 0,
      items: [],
      search: "",
      loading: true,
      options: {},
      editedId: "",
      confirmAction: null,
      headers: [
        {
          text: 'Přihlašovací jméno',
          value: 'username',
        },
        {
          text: 'Oprávnění',
          value: 'admin',
        },
        {
          text: 'Akce',
          value: 'actions',
          sortable: false
        },
      ],
    }
  },
  watch: {
    options: {
      handler () {
        this.loadDataFromServer()
      },
      deep: true,
    },
    search: {
      handler () {
        this.loadDataFromServer()
      },
    },
  },
  methods: {
    loadDataFromServer () {
      this.loading = true;
      api
          .get('user.php')
          .then(response => {
            console.log('response', response);
            this.items = response.data.items;
            this.total = response.data.total;
            this.loading = false;
          })
          .catch(defaultApiErrorHandler);
    },

    editItem (item) {
      this.editedId = item.id;
    },
    deleteItem (item) {
      let _this = this;
      this.confirmAction = function () {
        api
            .delete('user.php?id=' + item.id)
            .then(response => {
              console.log('response', response);
              _this.loadDataFromServer();
            })
            .catch(defaultApiErrorHandler);
      }
    },
  },
}
</script>
